import { gql } from 'apollo-boost';

const manyQuery = gql`
  query certificationsAthletes(
    $inputFilter: CertificationsAthleteFilterInputType
  ) {
    certificationsAthletes(inputFilter: $inputFilter) {
      id
      athleteId
      trainerId
      rank
      statusExamination
      certificationsId
      statusStatementAthlete
      statusProtocol
      contributions {
        id
        addedAt
        year
        amount
        type
        createdAt
        updatedAt
        userId
        trainerId
      }
      athlete {
        id
        fullName
      }
      trainer {
        id
        fullName
      }
    }
  }
`;

const oneQuery = gql`
  query certificationsAthlete($id: Int!) {
    certificationsAthlete(id: $id) {
      id
      athleteId
      rank
      statusExamination
      certificationsId
      trainerId
      statusStatementAthlete
      trainer {
        id
        fullName
      }
      athlete {
        id
        fullName
      }
    }
  }
`;

export const createMutation = gql`
  mutation createCertificationsAthletes(
    $inputData: CertificationAthleteInputType!
  ) {
    createCertificationsAthletes(inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const updateMutation = gql`
  mutation updateCertificationsAthletes(
    $id: Int!
    $inputData: CertificationAthleteUpdateInputType!
  ) {
    updateCertificationsAthletes(id: $id, inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;
export const openMutation = gql`
  mutation openStatement($id: Int!, $trainerId: Int!) {
    openStatement(id: $id, trainerId: $trainerId) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;
export const closeMutation = gql`
  mutation closeStatement($id: Int!, $trainerId: Int!) {
    closeStatement(id: $id, trainerId: $trainerId) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;
export const closeProtocolMutation = gql`
  mutation closeProtocol($id: Int!, $rank: String!) {
    closeProtocol(id: $id, rank: $rank) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;
export const doneMutation = gql`
  mutation doneAthleteRank($id: Int!, $athleteId: Int!, $rank: String!) {
    doneAthleteRank(id: $id, athleteId: $athleteId, rank: $rank) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;
export const undoneMutation = gql`
  mutation undoneAthleteRank($id: Int!, $athleteId: Int!, $rank: String!) {
    undoneAthleteRank(id: $id, athleteId: $athleteId, rank: $rank) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;
export const deleteMutation = gql`
  mutation deleteCertificationsAthletes($id: Int!) {
    deleteCertificationsAthletes(id: $id) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;
export const generateProfileInfoMutation = gql`
  mutation generateProtocolPdf(
    $id: Int!
    $rank: String!
    $protocolId: String!
  ) {
    generateProtocolPdf(id: $id, rank: $rank, protocolId: $protocolId) {
      ok
      url
      errors {
        field
        messages
      }
    }
  }
`;

const CERTIFICATION_ATHLETE = {
  manyQuery,
  oneQuery,
  createMutation,
  updateMutation,
  openMutation,
  closeMutation,
  closeProtocolMutation,
  doneMutation,
  undoneMutation,
  deleteMutation,
  generateProfileInfoMutation,
};

export default CERTIFICATION_ATHLETE;
